import React from 'react';
import Radium from 'radium';

import AppConstants from 'AppConstants';
import AppUtil from 'AppUtil';

import HttpService from 'service/HttpService';

import {A, Button} from 'views/AppElements';

import copy from 'copy-to-clipboard';

const styles = {
	copyIcon: {marginLeft: '10px', padding: '5px', background: '#eee', color: '#3a3535', cursor: 'pointer'},
	socialMediaBtn: {padding: '5px 10px', flexGrow: '1', textAlign: 'center', marginRight: '5px', color: 'black', 
								border: '1px solid #eee', background: 'white', textDecoration: 'none', marginTop: '10px',
								':hover': {color: 'gray'}}
}

class ProductSocialShare extends React.Component {
	constructor(props){
		super(props);
		this.state = {copied: false};
		this.onCopy = this.onCopy.bind(this);
	}

	onCopy(fullProductURL) {
		this.setState({copied: false});
		HttpService.bitlyShortenURL(fullProductURL, function(shortURL) {
			this.setState({copied: copy(shortURL)});
		}.bind(this));
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevProps.productImage !== this.props.productImage)
			this.setState({copied: false});
	}

	render() {
		const product = this.props.product;
		const img = this.props.productImage;

		const fullProductURL = AppConstants.WEBSITE + AppUtil.getProductURL(product) + "?sc_img=" + img;

		return <div>
					<h4 style={{fontSize: '90%', color: 'gray'}}>
						<i className="fa fa-exclamation-circle" aria-hidden="true"></i> Use the link below to share on Facebook, Twitter, Blog and other platforms.
					</h4>

					<div className='flexRow'>
						<input type="text" value={fullProductURL} readOnly={true} style={{flexGrow: '1', padding: '5px 10px'}}/>
						<Button style={styles.copyIcon} onClick={this.onCopy.bind(this, fullProductURL)}><i className="fa fa-files-o" aria-hidden="true" /> Copy</Button>
					</div>
						

					{
						this.state.copied &&
						<small>Copied. You can paste it now.</small>
					}

					<div className='flexRow'>
						<A href="https://www.facebook.com/setocanvascom" style={styles.socialMediaBtn}><i className="fa fa-facebook" aria-hidden="true"></i> Facebook</A>
						<A href="https://twitter.com/" style={styles.socialMediaBtn}><i className="fa fa-twitter" aria-hidden="true"></i> Twitter</A>
						<A href="https://www.instagram.com/setocanvas/" style={[styles.socialMediaBtn, {marginRight: '0px'}]}><i className="fa fa-instagram" aria-hidden="true"></i> Instagram</A>
					</div>

					<div style={{marginTop: "5px", color: 'gray', fontSize: '90%'}}>
						<span>For any inquiry, call us at <i style={{color: "#f8941c"}} className="fa fa-phone-square" aria-hidden="true"></i> {AppConstants.CONTACT_NUMBER} or WhatsApp at <i style={{color: "green"}} className="fa fa-whatsapp" aria-hidden="true"></i> {AppConstants.WHATS_APP}.</span>
					</div>
				</div>
	}
}

export default Radium(ProductSocialShare);


// WEBPACK FOOTER //
// ./src/views/product/ProductSocialShare.js